/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/internalGetAutomatedReleasesOverrides';

export type InternalGetAutomatedReleasesPathParams = NonNullable<
  operations['internalGetAutomatedReleases']['parameters']['path']
>;

export type InternalGetAutomatedReleasesQueryParams = NonNullable<
  operations['internalGetAutomatedReleases']['parameters']['query']
>;

export interface Input extends InternalGetAutomatedReleasesPathParams {
  apiVersion?: string;
  query?: InternalGetAutomatedReleasesQueryParams;
}

export async function internalGetAutomatedReleases(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/flags/{flagKey}/automated-releases', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
